import { render, staticRenderFns } from "./ShowMoreText.vue?vue&type=template&id=b8396ac2&scoped=true"
import script from "./ShowMoreText.vue?vue&type=script&lang=js"
export * from "./ShowMoreText.vue?vue&type=script&lang=js"
import style0 from "./ShowMoreText.vue?vue&type=style&index=0&id=b8396ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8396ac2",
  null
  
)

export default component.exports